module.exports = __webpack_public_path__ + "img/calling-warn-icon.50fb7978.png";